import React from 'react';
import createSVG from './createSVG';

const FacebookIcon = ({style}) => (
  <path style={style} fill="#C8C8C8" d="M16.37.415L12.445.409c-4.408 0-7.258 2.924-7.258 7.447v3.435H1.241c-.34 0-.616.275-.616.616v4.976c0 .339.276.616.616.616h3.946v12.554c0 .34.277.617.618.617h5.146c.341 0 .618-.277.618-.617V17.499h4.613c.342 0 .617-.277.617-.616l.003-4.976c0-.163-.066-.32-.182-.437-.115-.115-.272-.179-.436-.179h-4.615V8.379c0-1.399.334-2.109 2.155-2.109l2.644-.001c.342 0 .617-.277.617-.617V1.033c0-.341-.275-.616-.615-.618" mask="url(#b)"/>
);

export default createSVG(FacebookIcon);
